import dayjs from "dayjs";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var RecallHistoryMobileView = [{
        type: FormItemTypes.Box,
        name: '',
        sx: {
            bgcolor: 'secondary.50'
        },
        padding: '12px ',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Recall Name:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Docname',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.Docname) {
                                var Docname = formData !== null && formData !== void 0 && formData.Docname ? formData === null || formData === void 0 ? void 0 : formData.Docname : '-';
                                return Docname;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Document date:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Docdate',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var JobCardDate = formData !== null && formData !== void 0 && formData.Docdate ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.Docdate).format('DD MMM, YYYY') : '-';
                            return JobCardDate;
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Part/Service name:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'PartServiceName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.PartServiceName) {
                                var PartServiceName = formData !== null && formData !== void 0 && formData.PartServiceName ? formData === null || formData === void 0 ? void 0 : formData.PartServiceName : '-';
                                return PartServiceName;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Job Card No:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'JobCardNo',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.JobCardNo) {
                                var JobCardNo = formData !== null && formData !== void 0 && formData.JobCardNo ? formData === null || formData === void 0 ? void 0 : formData.JobCardNo : '-';
                                return JobCardNo;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Job Card Date:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'JobCardDate',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var JobCardDate = formData !== null && formData !== void 0 && formData.JobCardDate ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.JobCardDate).format('DD MMM, YYYY') : '-';
                            return JobCardDate;
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Racall Reason:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'RacallReason',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.RacallReason) {
                                var RacallReason = formData !== null && formData !== void 0 && formData.RacallReason ? formData === null || formData === void 0 ? void 0 : formData.RacallReason : '-';
                                return RacallReason;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Reference no:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'ReferenceNo',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.ReferenceNo) {
                                var ReferenceNo = formData !== null && formData !== void 0 && formData.ReferenceNo ? formData === null || formData === void 0 ? void 0 : formData.ReferenceNo : '-';
                                return ReferenceNo;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Supplier invoice no:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'SupplierInvoiceNo',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.SupplierInvoiceNo) {
                                var SupplierInvoiceNo = formData !== null && formData !== void 0 && formData.SupplierInvoiceNo ? formData === null || formData === void 0 ? void 0 : formData.SupplierInvoiceNo : '-';
                                return SupplierInvoiceNo;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Supplier invoice date:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'SupplierInvoiceDate',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var SupplierInvoiceDate = formData !== null && formData !== void 0 && formData.SupplierInvoiceDate ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.SupplierInvoiceDate).format('DD MMM, YYYY') : '-';
                            return SupplierInvoiceDate;
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Status:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'ISRecalled',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.ISRecalled) {
                                var ISRecalled = formData !== null && formData !== void 0 && formData.ISRecalled ? formData === null || formData === void 0 ? void 0 : formData.ISRecalled : '-';
                                return ISRecalled;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }]
    }];
